import { Controller } from "@hotwired/stimulus"
import { getSelectedIds } from "../../../../helpers/bulkActionHelpers"

export default class extends Controller {
  static targets = [ "bulkReportLink" ]

  connect() { }

  updateBulkReportLink() {
    if (!this.hasBulkReportLinkTarget) {
      return
    }

    const target = this.bulkReportLinkTarget
    const url = new URL(target.dataset.url, window.location.origin)
    const ids = getSelectedIds(target.dataset.scope).split(", ")
    ids.forEach(id => url.searchParams.append("ids[]", id))

    target.href = url.toString()
  }
}
